function escapeRegExp(text: string) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

type HighlightedPartProps = {
  text: string;
  highlight: string;
  highlightColor?: string;
  className?: string;
};

export function HighlightedPart({ text, highlight, highlightColor = "#FF9E24", className }: HighlightedPartProps) {
  if (!highlight || !text.includes(highlight)) {
    return <span className={className}>{text}</span>;
  }

  const escapedHighlight = escapeRegExp(highlight);
  const regex = new RegExp(`(${escapedHighlight})`, "g");

  const parts = text.split(regex);

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part === highlight ? (
          <span key={index} style={{ color: highlightColor }}>
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        ),
      )}
    </span>
  );
}
